import React, {useState, useRef, useEffect} from "react";
import * as classes from './Map.module.scss'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { getFileName } from '../../helpers/FileCatching';
import { trackCustomEvent } from "../../helpers/tracking";
import MapPin from "./images/pin.inline.svg"
import LeftArrow from "./images/left.inline.svg"
import RightArrow from "./images/right.inline.svg"
import TouchImage from "./images/mapMove.inline.svg"
import Panel from "./Components/Panel/Panel"
import Slider from "react-slick";

import useWindowSize from '../../helpers/useWindowSize'

const contentImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

let defaultPinIndex = 13

function Map({content, GlobalData}){

    let mapPinRef = useRef();
    let mapContainer = useRef();
    let mapPinRefs = useRef();
    let mapRef = useRef();
    let sliderRef = useRef();
    let mapPins = content.mapPins;
    let [chosenPinIndex, setChosenPinIndex] = useState(defaultPinIndex);
    let [instructionCopy, setInstructionCopy] = useState(null);
    let positionShift = {x:530, y:601};
    const [,,size] = useWindowSize();

    let instructionContainer = useRef();

    let [carouselSettings, setCarouselSettings] = useState({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect:true,
        swipeToSlide:true,
        arrows:false,
    });

    function onSliderChange(index){
        setChosenPinIndex(index)
        instructionContainer.current.classList.add(classes.Map__instruction__active);

    }

    function onPanelClose(){
        setChosenPinIndex(-1);
        instructionContainer.current.classList.add(classes.Map__instruction__active);
    }

    function test(){
        console.log("move")
    }

    useEffect(() => {
        moveToChosenIndex()
    },[size])

    useEffect(() => {
        if(size === "tablet" || size === "mobile"){
            setInstructionCopy("Scroll through to explore");
        }
        else{
            setInstructionCopy("Drag the map to explore");
        }
    },[size])
    
    useEffect(() => {

        if(defaultPinIndex!=chosenPinIndex && chosenPinIndex!=-1){
            let trackObject = {
                category: GlobalData.tracking.gaCategory,
                action: "hotspot click ",
                label: mapPins[chosenPinIndex].location
            }
            trackCustomEvent(trackObject);
        }
        moveToChosenIndex()
        moveCarouselToChosenIndex()
    },[chosenPinIndex])

    function moveToChosenIndex(){
        if(chosenPinIndex != -1 && mapRef.current !== null){
            let targetPosition = JSON.parse(JSON.stringify(mapPins[chosenPinIndex].position));
            let mdScreenShift = 0;

            targetPosition.x += positionShift.x
            targetPosition.y += positionShift.y

            switch (size) {
                case "mobile":
                        mdScreenShift = -90
                    break
                case "tablet":
                        mdScreenShift = -200
                    break;
            
                default:
                        mdScreenShift = 120
                    break;
            }
            mapRef.current.setTransform(-(targetPosition.x+22.5)+(window.innerWidth/2), (-targetPosition.y+mdScreenShift+(mapContainer.current.offsetHeight/2)));
        }
        
        console.log(defaultPinIndex,chosenPinIndex)

    }

    function moveCarouselToChosenIndex(){
        if(!defaultPinIndex){
            if(sliderRef.current && defaultPinIndex!=chosenPinIndex){
                sliderRef.current.slickGoTo(chosenPinIndex,true)
            }
        }
        defaultPinIndex = null;
    }

    function carouselPanels(){
        return(
            mapPins.map((item, index) =>
            
                <div key={index}>
                    <div style={
                        {
                            position:"relative", 
                            opacity:(index == chosenPinIndex ? 1 : 0.5),
                            transition:"opacity .25s ease-in-out"
                        }
                    }
                    >
                        <Panel content={item} active={(index == chosenPinIndex ? true : false)}/>
                    </div>
                </div>

            )
        )
    }

    function mapLocations(){

        return(
            mapPins.map((item, index) =>
                <span key={index} ref={(ref) => {mapPinRefs.current[index] = ref}} ref={mapPinRef} className={(chosenPinIndex==index ? `${classes.Map__pin} ${classes.Map__pinActive}` : classes.Map__pin)} style={
                    {
                        left:item.position.x + positionShift.x,
                        top:item.position.y + positionShift.y
                    }
                }>
                    <MapPin onClick={() => {
                        let targetPosition = JSON.parse(JSON.stringify(item.position));
                        
                        //Adjust
                        targetPosition.x += positionShift.x
                        targetPosition.y += positionShift.y

                        setChosenPinIndex(index)
                        instructionContainer.current.classList.add(classes.Map__instruction__active);
                    }
                } />
                    {
                        (
                            size != "tablet" && size != "mobile"
                            ?
                            <Panel onClosed={onPanelClose} content={item} active={(chosenPinIndex==index ? true : false)}/>
                            :
                            ""
                        )
                    }
                    
                </span>
            )
        )
    }

    return (
        <div className={classes.Map} ref={mapContainer}>
            <div className={classes.Map__instruction} ref={instructionContainer}>
                <div className={classes.Map__instruction__content_container}>
                    <p className={classes.Map__instruction__copy}>{instructionCopy}</p>
                    <div className={classes.Map__instruction__image_container}>
                        <div><LeftArrow/></div>
                        <div className={classes.Map__instruction__touch}><TouchImage/></div>
                        <div><RightArrow/></div>
                    </div>
                </div>
            </div>
            <TransformWrapper
                initialScale={1}
                initialPositionX={0}
                initialPositionY={0}
                maxScale={1}
                ref={mapRef}
                centerOnInit={true}
                panning={
                    {
                        disabled:(size == "tablet" ? true : false)
                    }
                }
                onPanning={() => {instructionContainer.current.classList.add(classes.Map__instruction__active);}}
                wheel={
                    {
                        disabled:true
                    }
                }
            >
                {({ }) => (
                <React.Fragment>
                    <TransformComponent wrapperClass={classes.Map__pan_wrapper}
                    onPanning={() => {instructionContainer.current.classList.add(classes.Map__instruction__active);}}
                    >
                        <img src={getFileName(contentImages,content.image.desktop).default} alt="Map of the world" />
                        {
                            mapLocations()
                        }
                    </TransformComponent>
                </React.Fragment>
                )}
            </TransformWrapper>
            {
                (
                    size == "tablet" || size == "mobile"
                    ?
                    <div className={classes.Map__slider_wrapper}>
                        <div className={classes.Map__slider_container}>
                            <Slider 
                                ref={sliderRef} 
                                beforeChange={(old, newIndex) => {onSliderChange(newIndex)}} 
                                className={classes.Map__slider_container} 
                                initialSlide={defaultPinIndex}
                                {...carouselSettings}>
                                {carouselPanels()}
                            </Slider>
                        </div>
                    </div>
                    :
                    ""
                )
            }

        </div>
    )
}

export default Map